import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useSelector } from "react-redux";
import clsx from "classnames";
import PropTypes from "prop-types";

const PopAlert = ({ title, children, ...props }) => {
    const layoutType = useSelector((state) => state.appReducer.layoutType);

    const baseClass = clsx({
        "text-dark font-weight-bolder": layoutType === "dark"
    });

    const displayTitle = <span className={baseClass}>{title}</span>;
    return (
        <SweetAlert title={displayTitle} {...props}>
            <span className={baseClass}>{children}</span>
        </SweetAlert>
    );
};

PopAlert.defaultProps = {
    confirmBtnText: "Okay",
    confirmBtnBsStyle: "success",
    cancelBtnBsStyle: "danger",
    btnSize: "sm",
    showCancel: true,
    showConfirm: true,
    title: ""
};

PopAlert.propTypes = {
    confirmBtnText: PropTypes.string,
    confirmBtnBsStyle: PropTypes.string,
    cancelBtnBsStyle: PropTypes.string,
    btnSize: PropTypes.string,
    showCancel: PropTypes.bool,
    showConfirm: PropTypes.bool,
    title: PropTypes.string
};

export default PopAlert;
